import { getMaskPath } from '../../../../utils/masks';
import { fabric } from 'fabric';

function _applyPathMask(ctx, width, height, path) {
  let left = (width / 2) * -1;
  let top = (height / 2) * -1;
  let scale = width / 100;
  let ratio = height / width;

  path.width = width;
  path.height = height;
  path.left = left * scale;
  path.top = top * scale * ratio;
  path.scaleX = scale;
  path.scaleY = scale * ratio;

  path.render(ctx);
}

export class GraphicItemMasks {
  static applyMask(ctx, maskType, width, height) {
    let path = new fabric.Path(getMaskPath(maskType));
    _applyPathMask(ctx, width, height, path);
  }
}
